import { render, staticRenderFns } from "./PracticeN.vue?vue&type=template&id=66182696&scoped=true&"
import script from "./PracticeN.vue?vue&type=script&lang=js&"
export * from "./PracticeN.vue?vue&type=script&lang=js&"
import style0 from "./PracticeN.vue?vue&type=style&index=0&id=66182696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66182696",
  null
  
)

export default component.exports